import { Settings, Settings2 } from "lucide-react";
import { useState, type FC } from "react";

import { SettingsModal } from "@/components/settings/SettingsModal";
import { Button } from "@/components/ui/button";

type Props = {
  label?: string;
  /** Shown instead of `label` in a narrow container (below `@lg`); never icon-only. */
  shortLabel?: string;
  className?: string;
  variant?: "ghost" | "secondary";
  size?: "xs" | "sm";
  /** The gear (`Settings`) rather than the sliders. */
  gear?: boolean;
  testId?: string;
};

/** Opens Settings > Case Preparation over the IDE. */
export const FirmDefaultsLink: FC<Props> = ({
  label = "Firm Defaults",
  shortLabel,
  className,
  variant = "ghost",
  size = "xs",
  gear = false,
  testId = "workflow-firm-defaults"
}) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        variant={variant}
        size={size}
        className={className}
        onClick={() => setOpen(true)}
        aria-label={shortLabel ? label : undefined}
        data-testid={testId}
      >
        {gear ? <Settings /> : <Settings2 />}
        {shortLabel ? (
          <>
            <span className="@lg:hidden">{shortLabel}</span>
            <span className="hidden @lg:inline">{label}</span>
          </>
        ) : (
          label
        )}
      </Button>
      {open ? (
        <SettingsModal
          open
          onOpenChange={setOpen}
          initialSection="case-preparation"
        />
      ) : null}
    </>
  );
};
